import SiteTheme from "../../model/SiteTheme";
import NavigationSet from "../../model/NavigationSet";

const _chase_links: NavigationSet = {
    Home: '/',
    Story: {
        Comic: '/comics/talechasers',
        Characters: '/characters',
        World: '/world'
    },
    Stream: {
        About: '/stream',
        "Bluerock Bay": '/stream/bluerock',
        "Vixy": '/stream/vixy',
        "Pokemon": '/stream/pokemon',
        Mario: '/stream/mario',
        SAR: '/stream/sar',
        Charities: '/stream/charities',
    },
    Art: {
        Commissions: '/commissions',
        Galleries: '/galleries',
        "Telegram Stickers": '/telegram-stickers',
        Shop: '/shop',
    },
    Fun: {
        "Fursona Generator": '/fursona-generator',
        "TF Generator": '/tf-generator',
        "Choose Your Starter": '/choose-your-starter'
    },
    "Site Info": {
        Credits: '/credits',
        "Patch Notes": '/patch-notes',
        Downloads: '/downloads'
    }
};

const ChaseTheme: SiteTheme = {
    bannerImage: `https://cdn.chasethefox.com/m/chase/theme/logo.png`,
    bannerImageCircular: true,
    bannerTitle: `https://cdn.chasethefox.com/m/chase/theme/title.png`,
    bannerTitleAlt: "Chase the Fox",
    navigationLinks: _chase_links,
    fullReloadLinks: ['/cga']
};

export default ChaseTheme;